<template>
    <div class="" :style="style">
        <template v-if="layout == 'img'">
            <div class="bg-white text-dark p-0 m-0 border-0"  body-class="">
                <b-img center fluid  v-if="url" :src="url" class="p-0 m-0" alt="..."></b-img>
                <!-- <div class="card-img-overlay p-4 align-self-center d-flex justify-content-center"> -->
                    <!-- <h2 class="card-title  align-self-center d-flex justify-content-center border border-cdark p-2">{{config.title}}</h2> -->
                <!-- </div> -->
                <!-- <b-container v-if="action" style="position: relative; bottom:3rem;" class="text-left">
                    <b-button-group class="text-white" v-if="action.type == 'login'">
                        <b-button variant="orange" class="">{{ action.text }}</b-button>
                        <b-button>Button 2</b-button>
                    </b-button-group>
                </b-container> -->
            </div>
            
        </template>
        <template v-if="layout == 'text'">
            <div class="h4 font-weight-bold m-0 pt-3 block align-middle p-0">
                {{text.cn}}
                <div style="position:relative; top:-1rem;opacity: 0.2;" class="text-gray">{{text.en}}</div>
            </div>
            
        </template>
        
    </div>
        
    
  </template>
  
  <script>
  
import store from '@/store'

import banner from '@/assets/banner1.png'

  import { getXianZhuang,getJianBao } from '@/api/api.js'
  export default {
    name: 'banner',
    props: {
        url:{
            type:String,
            default(){
                return banner // url
            }
        },
        action:{
            type:Object,
            default(){
                return null 
            }
        },
        layout:{
            type:String,
            default(){
                return 'img'   // img   text 
            }
        },
        text:{
            type:Object,
            default(){
                return {
                    cn:'',
                    en:''
                } 
            } 
        },
        height:{
            type:[String,Number],
            default(){
                return 160   // img   text 
            } 
        }
    },
    computed:{
        style(){
            let style = {}
            let height = this.height
            if(height){
                style['height'] = `${height}px`
                style['max-height'] = `${height}px`
                style['max-height'] = `${height}px`
                style['overflow'] = `hidden`
            }
            return style
        }
    },
    mounted(){
        // this.getData()  
    },
    data() {
      return {
        
      }
    },
      methods: {
        
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.card-img{
  min-height: 8rem;
}
  </style>
  